import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Contacto from './pages/Contacto';
import Locales from './pages/Locales';
import Faqs from './pages/Faqs';
import Terminos from './pages/Terminos';
import ProteccionDatos from './pages/ProteccionDatos';
import LocaleDetalle from './pages/LocaleDetalle';
import NotFound from './pages/NotFound';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="contacto" element={<Contacto />} />
            <Route path="locales" element={<Locales />} />
            <Route path="locales/:slug" element={<LocaleDetalle />} />
            <Route path="faqs" element={<Faqs />} />
            <Route path="terminos" element={<Terminos />} />
            <Route path="proteccion-datos" element={<ProteccionDatos />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
